module.exports = __webpack_public_path__ + "img/excesoVelocidad.31de8e27.svg";